import { EFonts } from 'libs/styles/styling';

export const SelectValueStyle = {
    control: (provided) => ({
        ...provided,
        borderRadius: '7px',
        border: '1px solid #DADADA',
        background: '#F5F5F5',
        boxShadow: '0px 0px 20px 0px #DEDEDE inset',
        color: '#141C54',
        cursor: 'pointer',
        fontSize: '13px',
        fontFamily: EFonts.Regular,
        '&:hover': {
            border: '1px solid #DADADA'
        },
        '&:focus': {
            border: '1px solid #DADADA',
            boxShadow: 'none',
            outline: 'none'
        }
    }),
    option: (provided) => ({
        ...provided,
        fontSize: '13px',
        color: '#141C54',
        fontFamily: EFonts.Regular,
        cursor: 'pointer',
        paddingTop: '10px',
        paddingBottom: '10px',
        borderBottom: '1px solid #dadada',
        boxShadow: '0px 0px 20px 0px #DEDEDE inset',
        '&:hover': {
            color: '#141C54',
            backgroundColor: '#3B3B3B',
            boxShadow: 'none'
        },
        '&:nth-child(odd)': {
            background: '#F5F5F5'
        },
        '&:nth-child(even)': {
            background: '#F5F5F5'
        }
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#141C54',
        fontFamily: EFonts.Regular
    }),
    menu: (provided) => ({
        ...provided,
        background: '#F5F5F5',
        overflow: 'hidden'
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '0',
        //style scrollbar
        '&::-webkit-scrollbar': {
            width: '15px'
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#F5F5F5',
            boxShadow: '0px 0px 20px 0px #DEDEDE inset'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#F5F5F5',
            borderRadius: '0px'
        }
    }),
    input: (provided) => ({
        ...provided,
        fontSize: '13px',
        color: '#141C54',
        fontFamily: EFonts.Regular,
        '&:focus': {
            backgroundColor: '#3B3B3B',
            outline: 'none'
        }
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: 'none'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#141C54',
        '&:hover': {
            color: '#141C54'
        }
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#141C54',
        '&:hover': {
            color: '#141C54'
        }
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#141C54',
        fontSize: '13px',
        background: '#F5F5F5',
        boxShadow: '0px 0px 20px 0px #DEDEDE inset',
        fontFamily: EFonts.Regular
    }),
    loadingMessage: (provided) => ({
        ...provided,
        color: '#141C54',
        fontSize: '13px',
        background: '#F5F5F5',
        boxShadow: '0px 0px 20px 0px #DEDEDE inset',
        fontFamily: EFonts.Regular
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#909090',
        fontFamily: EFonts.Regular
    })
};
